import { FC, memo } from "react"
import { IWalletCounters } from "@/ui/WalletCounters/types"
import { CurrencyPlaque } from "@/ui/WalletCounters/ui"
import styles from "./WalletCounters.module.scss"

const WalletCountersComponent: FC<IWalletCounters> = ({
  counters,
  onToggleHint
}) => (
  <div className={styles.WalletCounters}>
    {counters.map((counter) => (
      <CurrencyPlaque
        key={counter.currencyCode}
        counter={counter}
        onToggleHint={onToggleHint}
      />
    ))}
  </div>
)

export const WalletCounters = memo(WalletCountersComponent)
